export default __webpack_public_path__ + "static/media/Mark-3-Suit-07.f19057ef.jpg";